import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Tabs, Button, Modal, Alert } from "antd";
import { BulbOutlined, SnippetsOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { SugestoesColaboradores } from "./components/colaboradores";
import { SugestoesComo } from "./components/como";
import { SugestoesSugestao } from "./components/sugestao";
import { SugestoesAnexos } from "./components/anexos";
import http from "../../../services/http";
const { Text } = Typography;

export const SugestoesDetalhamentoInicial = () => {
  const { id_sugestao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dadosSugestao, setDadosSugestao] = useState(null);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (id_sugestao > 0) {
      carregarSugestao(id_sugestao);
    } else {
      navigate("/sugestoes");
    }
  }, [id_sugestao]);

  // CARREGAR SUGESTÃO
  const carregarSugestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/sugestoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data?.status !== -1 && api?.response?.data?.status !== 0) {
        message.error("Operação inválida!");
        navigate("/sugestoes");
      }
      setDadosSugestao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/sugestoes");
    }
    setLoading(false);
  };

  // ENVIAR PARA AVALIAÇÃO
  const enviarSugestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/sugestoes/enviar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Sugestão enviada para avaliação!");
      navigate("/sugestoes");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const items = [
    {
      key: "1",
      label: `Sugestão`,
      children: <SugestoesSugestao idSugestao={id_sugestao} />,
    },
    {
      key: "2",
      label: `Como?`,
      children: <SugestoesComo idSugestao={id_sugestao} />,
    },
    {
      key: "3",
      label: `Colaboradores`,
      children: <SugestoesColaboradores idSugestao={id_sugestao} />,
    },
    {
      key: "4",
      label: `Anexos`,
      children: <SugestoesAnexos idSugestao={id_sugestao} />,
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/sugestoes")} />
            <HeaderTitle
              title="Sugestões Detalhamento Inicial"
              subtitle={
                <Text italic>
                  <BulbOutlined /> {dadosSugestao?.titulo ?? ""}
                </Text>
              }
              icon={<SnippetsOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Tabs
                defaultActiveKey="1"
                items={items}
                tabBarExtraContent={{
                  right: (
                    <Button
                      icon={<CheckCircleOutlined />}
                      onClick={() => {
                        modal.confirm({
                          title: "Deseja finalizar esta sugestão?",
                          okText: "Sim",
                          content: (
                            <Alert
                              message="Verifique se todas as etapas estão preenchidas antes de enviar!"
                              type="info"
                              showIcon
                            />
                          ),
                          cancelText: "Cancelar",
                          onOk() {
                            enviarSugestao(id_sugestao);
                          },
                        });
                      }}>
                      Enviar
                    </Button>
                  ),
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
